import { statesOptions } from '@dispatch/shared/options';
import { MultiSelectOption } from '@dispatch/shared/types';
import { SelectField } from '@dispatch/web/ui';
import { Control, FieldErrors } from 'react-hook-form';

export const RenderQualifier = ({
  ifStatement,
  index,
  errors,
  control,
  perilOptions,
}: {
  ifStatement: string;
  index: number;
  errors: FieldErrors;
  control: Control<any, any>;
  perilOptions: MultiSelectOption[];
}) => {
  let label: string;
  let options: MultiSelectOption[];

  switch (ifStatement) {
    case '$msg.claim.lossLocation.state':
      label = 'State';
      options = [...statesOptions];
      break;
    case '$msg.claim.peril':
      label = 'Peril';
      options = perilOptions;
      break;
    default:
      label = '';
      options = [];
  }

  const findOption = (option: unknown) => {
    return options.find(
      ({ value: findValue }) => findValue === (option as string | number)
    );
  };

  const getStateLabel = (option: MultiSelectOption): string => {
    if (ifStatement !== '$msg.claim.lossLocation.state') return '';
    let currentOption = '';
    if (option?.value) {
      currentOption = option.value as string;
    } else {
      const result = findOption(option);
      if (result) {
        currentOption = result?.value as string;
      }
    }
    return currentOption;
  };

  let optionalProps = {};
  // for the states we want to resolve to show the abbreviation
  // but for peril we want the title. This check will add the override if state
  if (ifStatement === '$msg.claim.lossLocation.state') {
    optionalProps = {
      overrideOptionsLabel: getStateLabel,
    };
  }

  return (
    <SelectField
      {...optionalProps}
      data-testid="qualifier-input"
      multiple
      id={`rules[${index}].meta`}
      name={`rules[${index}].meta`}
      label={label}
      control={control}
      errors={errors}
      error={errors['rules'] ? errors['rules'][index]?.meta?.message : null}
      options={options}
    />
  );
};
